// extracted by mini-css-extract-plugin
module.exports = {"element":"error-page_element__14w1t","copy":"error-page_copy__HySNT","link":"error-page_link__2OhP4"};